export const DefaultService = {
  async onCreate() {},
};
